import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-up-right', 'ArrowUpRight', [["path",{"d":"m6.5 17.5 11-11m0 9v-9h-9","key":"svg-0"}]]);